import React, { Component, Fragment } from "react";
import Header from "../../../components/Layout/Header/HeaderRewards";
import AlertMessage from "../../../common/AlertMessage/AlertMessage";
import {
  changeActiveTab,
  showLoader,
} from "../../../App/redux/action";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import Footer from "../../../components/Layout/Footer/Footer";
import Privilege from "./components/Privilege";

const mapStateToProps = (state) => {
  return {
    merchantDetailsResponse: state.reducerDashboard.merchantDetailsResponse,
  };
};

const mapDispatchToProps = {
  changeActiveTab,
};

class RewardsContainer extends Component {
  render() {
    return (
      <Fragment>
        <Header />
        <AlertMessage />
        <Privilege
          openLoader={showLoader}
          merchantDetailsResponse={this.props.merchantDetailsResponse}
        />
        <Grid item>
          <Footer />
        </Grid>
      </Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RewardsContainer);
